// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HrYlAtvXI88K2pWzf11m{width:100%}.izJf3LFPawscArGSNxij{margin-top:40px}.THG7ssjcoVkg9CPz5lkV{font-size:13px;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `HrYlAtvXI88K2pWzf11m`,
	"descriptionField": `izJf3LFPawscArGSNxij`,
	"fieldText": `THG7ssjcoVkg9CPz5lkV`
};
export default ___CSS_LOADER_EXPORT___;
